import SubscribePage from "./SubscribePage";

export default SubscribePage;